import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import AboutSubNav from '../../components/AboutSubNav';
import { FOUNDER } from '../../mock/mock';

const Founder = () => {
  return (
    <div>
      <section className="pt-24 pb-16 bg-[#f2ebde]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs tracking-[0.32em] uppercase text-[#a67c3d] mb-5">Family-Led Since 1964</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#1a1614] leading-[1.05] max-w-4xl">
            The Agarwal family <span className="italic text-[#a67c3d]">&mdash; three generations of craft.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-[#4a3f36] leading-relaxed">
            {FOUNDER.intro}
          </p>
        </div>
      </section>

      <AboutSubNav />

      {/* Hero shared photo — rotated & object-position tuned to keep focus on the persons */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="relative overflow-hidden bg-[#1a1614] max-w-2xl mx-auto aspect-[3/4]">
            {/* Rotated wrapper — landscape 4:3 box that, after -90deg rotation, fills the 3:4 portrait container. */}
            <div
              className="absolute"
              style={{
                top: '50%',
                left: '50%',
                width: '133.33%',
                height: '75%',
                transform: 'translate(-50%, -50%) rotate(90deg)',
                transformOrigin: 'center center'
              }}
            >
              <img
                src={FOUNDER.sharedPhoto}
                alt="Mr. Samir Agarwal with Poorvi and Sakshi Agarwal"
                className="w-full h-full object-cover"
                style={{ objectPosition: 'center 62%', transform: 'scale(1.25)' }}
                loading="lazy"
              />
            </div>

            {/* Bottom gradient + caption */}
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#1a1614]/90 via-[#1a1614]/30 to-transparent p-6 md:p-10 pt-24 md:pt-32 z-10">
              <p className="text-[10px] md:text-xs tracking-[0.32em] uppercase text-[#d4b483] mb-2">
                Family Leadership
              </p>
              <h2 className="font-serif text-2xl md:text-4xl text-[#faf6f0] leading-tight">
                Samir, Poorvi &amp; Sakshi Agarwal
              </h2>
            </div>
          </div>
        </div>
      </section>

      {/* Individual bios */}
      <section className="pb-24 md:pb-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            {FOUNDER.directors.map((d, i) => (
              <div key={d.name} className="relative">
                <div className="flex items-baseline gap-4 mb-5">
                  <span className="font-serif text-lg text-[#a67c3d]">0{i + 1}</span>
                  <div className="h-px flex-1 bg-[#e0d6c5]" />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-[#1a1614] mb-2">{d.name}</h3>
                <p className="text-xs tracking-[0.24em] uppercase text-[#a67c3d] mb-6">{d.title}</p>
                <p className="text-[#4a3f36] leading-relaxed text-sm md:text-base">{d.bio}</p>
              </div>
            ))}
          </div>

          <div className="max-w-3xl mx-auto text-center py-16 mt-16 border-t border-[#e0d6c5]">
            <p className="text-sm text-[#6b5847] italic mb-10">{FOUNDER.legacyNote}</p>
            <Quote size={22} className="mx-auto text-[#a67c3d] mb-4" />
            <p className="font-serif text-2xl md:text-3xl italic text-[#1a1614] leading-snug px-6">
              &ldquo;{FOUNDER.quote}&rdquo;
            </p>
          </div>

          <div className="flex flex-wrap justify-between items-center gap-6 pt-10 border-t border-[#e0d6c5]">
            <Link to="/about/history" className="rcd-link text-sm text-[#1a1614]">&larr; History</Link>
            <Link to="/about/clients" className="inline-flex items-center gap-2 px-6 py-3 bg-[#1a1614] text-[#faf6f0] hover:bg-[#a67c3d] transition-colors text-sm">
              See Our Clients <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Founder;
